import {AfterViewInit, Component, OnDestroy, OnInit} from '@angular/core';
import * as $ from 'jquery';
import {RolesListComponent} from './roles-list.component';
import {RolesService} from './roles.service';
import {IRol} from './rol';
import * as myGlobals from './../global';
import { errorMessageFromAjax } from '../services/ajax-error';

@Component({
  selector: 'pm-edit-rol',
  templateUrl: './edit.component.html',
  styleUrls: ['./edit.component.sass'],
  providers: [RolesService]
})
export class EditRolComponent implements OnInit, OnDestroy, AfterViewInit {
  roles: IRol[] = [];

  error: boolean;
  errorMessage = '';

  rol: IRol;

  constructor(public service: RolesService, private parent: RolesListComponent) {
  }

  ngOnInit(): void {
    console.log('OnInit: id: ', this.parent.editnumber);
    this.getRol(this.parent.editnumber);
  }

  ngAfterViewInit() {
    $('a[rel=roles]').addClass('selected');
  }

  edit(elemento): boolean {
    console.log('edit: ' + elemento.parent.editnumber);
    console.log('edit: form; ' + elemento);

    const formData = {
      name: $('input[name=name]').val(),
      status: $('#status option:selected').val()
    };
    console.log('edit: formData: ', formData);

    const parentRef = this.parent;

    $.ajax({
      url: myGlobals.baseApi + '/webadmin/v1/role/' + elemento.parent.editnumber,
      dataType: 'json',
      headers: {
        sessionToken: localStorage.getItem('sessionToken')
      },
      contentType: 'application/json; charset=utf-8',
      type: 'PUT',
      data: JSON.stringify(formData)
    }).done(function (response) {
      console.log('edit sucess!!');
      parentRef.showRoles = true;
      parentRef.showAddRol = false;
      parentRef.showEditRol = false;
    }).fail(function(jqXHR) {
      alert('No se pudo actualizar el rol: ' + errorMessageFromAjax(jqXHR));
    });
    return false;
  }

  getRol(id: number) {
    this.service.getRol(id).subscribe(rol => (this.rol = rol), error => (this.errorMessage = error as any));
  }

  cancelRol(): void {
    this.parent.showRoles = true;
    this.parent.showAddRol = false;
    this.parent.showEditRol = false;
  }

  ngOnDestroy() {
    $('a[rel=roles]').removeClass('selected');
  }
}
